module.exports = __webpack_public_path__ + "static/avs-video-editor-landing-ba2b33f04157a44ba5e543359b86b02c.svg";